import {Fragment} from "preact";
import {Dialog, Transition} from "@headlessui/react";
import {useStoreInfoModal} from "./useStoreInfoModal";
import {ScopedLoader} from "../../../index";
import Content from "./Content";
import {useAppContext} from "../../../../contexts";

const StoreInfoModal = (props) => {
    // Destructured props
    const {
        externalId,
        storeName,
        isOpen,
        setIsOpen
    } = props;

    // Component logic data
    const componentProps = useStoreInfoModal({
        externalId,
        isOpen
    });

    // Destructured component logic data
    const {
        storeData,
        isLoading
    } = componentProps;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    // Loader variable
    const loader = isLoading && (
        <div className={"py-14"}>
            <ScopedLoader />
        </div>
    );

    return (
        <Fragment>
            <Transition.Root show={isOpen} as={Fragment}>
                <Dialog as="div" className="relative z-[25]" onClose={setIsOpen}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" />
                    </Transition.Child>
                    <div className="fixed inset-0 z-10 overflow-y-auto">
                        <div className="flex min-h-full px-4 md:px-0 items-center justify-center text-center sm:items-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-700"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-300"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className={`relative transform overflow-hidden rounded-lg py-[1rem] md:py-8 px-[1rem] md:px-12 text-left shadow-xl duration-700 sm:max-w-[950px] w-screen flex items-start md:items-center ${highContrast ? "highGrayColor" : "bg-white"}`}>
                                    {loader}

                                    {/* Main content */}
                                    <Content
                                        storeName={storeName}
                                        data={storeData}
                                        setIsOpen={setIsOpen}
                                    />
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </Fragment>
    )
}

export default StoreInfoModal;
